module.exports = __webpack_public_path__ + "img/airtel.ae564da4.png";